// src/lib/sanity.ts
import { createClient } from '@sanity/client';

export const client = createClient({
  projectId: '3smqzwlu', // your Sanity project ID
  dataset: 'production',
  apiVersion: '2023-01-01', // or today's date in 'YYYY-MM-DD'
  useCdn: false, // Disable CDN for fresh data & avoid CORS issues in dev
});
